// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141959/js/" + chunkId + "." + {"44":"e8fa3c5c","225":"25161e4b","481":"556971d9","486":"f86075a3","770":"fdbf7c8d"}[chunkId] + ".0.6178618835894235.chunk.js";
};